import { useState, useEffect } from "react";
import { 
  subscribeToOpportunities, 
  addOpportunity, 
  updateOpportunity, 
  deleteOpportunity,
  addNoteToOpportunity,
  deleteNoteFromOpportunity
} from "../services/opportunitiesService";

export function useOpportunities() {
  const [opportunities, setOpportunities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let unsubscribe = () => {};

    try {
      setLoading(true);
      unsubscribe = subscribeToOpportunities((data, err) => {
        if (err) {
          setError("Failed to load opportunities.");
        } else {
          setOpportunities(data);
          setError("");
        }
        setLoading(false);
      });
    } catch (err) {
      console.error(err);
      setError("Failed to initialize opportunities subscription.");
      setLoading(false);
    }

    return () => unsubscribe();
  }, []);

  const handleAddOpportunity = async (data) => {
    try {
      setError("");
      return await addOpportunity(data);
    } catch (err) {
      console.error("Error adding opportunity:", err);
      setError(err.message || "Failed to add opportunity.");
      throw err;
    }
  };

  const handleUpdateOpportunity = async (id, data) => {
    try {
      setError("");
      await updateOpportunity(id, data);
    } catch (err) {
      console.error("Error updating opportunity:", err);
      setError(err.message || "Failed to update opportunity.");
      throw err;
    }
  };

  const handleDeleteOpportunity = async (id) => {
    try {
      setError("");
      await deleteOpportunity(id);
    } catch (err) {
      console.error("Error deleting opportunity:", err);
      setError(err.message || "Failed to delete opportunity.");
      throw err;
    }
  };

  const handleAddNote = async (id, text, author) => {
    try {
      setError("");
      return await addNoteToOpportunity(id, text, author);
    } catch (err) {
      console.error("Error adding note to opportunity:", err);
      setError(err.message || "Failed to add note.");
      throw err;
    }
  };

  const handleDeleteNote = async (id, note) => {
    try {
      setError("");
      await deleteNoteFromOpportunity(id, note);
    } catch (err) {
      console.error("Error deleting note from opportunity:", err);
      setError(err.message || "Failed to delete note.");
      throw err;
    }
  };

  return {
    opportunities,
    loading,
    error,
    setError,
    addOpportunity: handleAddOpportunity,
    updateOpportunity: handleUpdateOpportunity,
    deleteOpportunity: handleDeleteOpportunity,
    addNoteToOpportunity: handleAddNote,
    deleteNoteFromOpportunity: handleDeleteNote
  };
}
